export const queryAll = (selector, context = window.document) => {
  const elements = [];
  const results = context.querySelectorAll(selector);
  /* tslint:disable */

  for (let i = 0; i < results.length; i++) {
    /* tslint:enable */
    elements.push(results[i]);
  }

  return elements;
};



// WEBPACK FOOTER //
// ../work/src/js/utils/utils.js